// @flow

import { RECEIVED_FORMIDABLE_SETTINGS } from './constants';
import type { ReceivedFormidableSettings } from './actions';

const initialState = {
  form_submit_failed_error_text: '',
};

export type State = typeof initialState;

const formidableSettings = (
  state: State = initialState,
  action: ReceivedFormidableSettings,
): State => {
  switch (action.type) {
    case RECEIVED_FORMIDABLE_SETTINGS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default formidableSettings;
